export {};



// WEBPACK FOOTER //
// ./resources/assets/js/views/default.js